import React from 'react';
function Tag({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.515 13.525L13.53 19.51a1.667 1.667 0 01-2.362 0L4 12.348V4h8.346l7.169 7.17a1.67 1.67 0 010 2.355v0z"
      />
    </svg>
  );
}

export default Tag;
